export const sraDomain = 'https://sra-api.tis.coke.com'
export const sraPortalDomain = 'https://sra.tis.coke.com'
export const ncPortalDomain = 'https://nutrition-calculator.tis.coke.com'
export const sraSfdcDomain = 'https://ccnag.my.salesforce.com'
export const domain = 'https://apiazr.tis.coke.com'
export const azureClientId = '3ecd18d0-8767-441b-9d4c-63512e0ca42e'
export const azureTenantId = '548d26ab-8caa-49e1-97c2-a1b1a06cc39c'
export const apiKey = '3raCXCKojA7H7CcinqaZuYJGlp6qJ3z5THbLkz6c'
export const stage = 'prod'
export const featureFlags = {
  isShareEnabled: true
}